import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {getTagsList, Qualifiche} from "@commons/mapping/DataTablesSchema";
import {QualificaRecord, TabellaElementiRMLRecord} from "@commons/mapping/CentroDiCostoRecord";
import {addBaseQueryParams, addURI, IdAziendaParams, transformResponse} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";

export const aziendaQualificheApi = createApi({
    reducerPath: 'aziendaQualificaApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    tagTypes: ['aziendaQualifiche'],
    endpoints: (builder) => ({
        getAziendaQualifica: builder.query<Qualifiche, Partial<IdAziendaParams>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                const queryParams = `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
                return `/azienda/${filter.idAzienda}/tabella/qualifica` + queryParams;
            },
            transformResponse,
            providesTags: (result) => getTagsList<QualificaRecord>(result, 'aziendaQualifiche'),
        }),

        getElemento: builder.query<TabellaElementiRMLRecord, string | undefined>({
            query: (URI) => {
                return URI ? URI : `/${URI}`;
            },
            transformResponse: addURI
        }),

        deleteElemento: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
            invalidatesTags: [{type: 'aziendaQualifiche', id: 'LIST'}],
        }),

        updateElemento: builder.mutation<Partial<TabellaElementiRMLRecord>, Partial<TabellaElementiRMLRecord> & Pick<TabellaElementiRMLRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PUT', // 'PATCH'
                body: patch,
            }),
            transformResponse,
            invalidatesTags: (result, error, {URI}) => [{type: 'aziendaQualifiche', URI}],
        }),

        insertElemento: builder.mutation<Partial<TabellaElementiRMLRecord>, Partial<TabellaElementiRMLRecord>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (payload) => ({
                url: `/azienda/${payload.idAzienda}/tabella/elementi-RML`,
                method: 'POST',
                body: payload,
            }),
            transformResponse,
            invalidatesTags: [{type: 'aziendaQualifiche', id: 'LIST'}],
        }),
    }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAziendaQualificaQuery,
    useLazyGetElementoQuery,
    useUpdateElementoMutation,
    useInsertElementoMutation,
    useDeleteElementoMutation,
} = aziendaQualificheApi;